import { Component, OnDestroy, OnInit } from '@angular/core';
import { getBanner, getBannerSuccess } from '@app/actions/homepage/banner.action';
import { CommonConstant } from '@app/common/constant/common.constant';
import { CommonUtils } from '@app/common/util/common.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { MyRollingBannerModel } from '@app/models/homepage/my-rolling-banner.module';
import { BannerSearchState, loadBannerSearchItems } from '@app/selectors/homepage/banner.selector';
import { SwiperService } from '@app/services/common/swiper.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'hp-slider',
    templateUrl: './hp-slider.component.html',
    styleUrls: ['./hp-slider.component.css']
})
export class HpSliderComponent implements OnInit, OnDestroy {
    loadBannerItems$ = new Observable<MyRollingBannerModel[]>();
    contentsBanner: MyRollingBannerModel[] = [];

    contentPC: MyRollingBannerModel[] = [] as MyRollingBannerModel[];
    contentMobile: MyRollingBannerModel[] = [] as MyRollingBannerModel[];

    urlWownet: string = CommonConstant.URL_WOWNET;

    isMobile: boolean = false;

    swiperConfig = {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        loopedSlides: 1,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    }

    constructor(private _bannerStore: Store<BannerSearchState>,
        private _swiperService: SwiperService) {
        this.loadBannerItems$ = this._bannerStore.select(loadBannerSearchItems);
    }

    ngOnDestroy(): void {
        this._bannerStore.dispatch(getBannerSuccess({ banner: [] }));
    }

    ngOnInit(): void {
        this.loadBanner();
    }

    loadBanner(): void {
        let params = {
            kind: 'HP',
            dateNow: CommonUtils.getDateNow(),
        };

        this._bannerStore.dispatch(getBanner({ params: params }));

        this.loadBannerItems$.subscribe((res) => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.contentsBanner = res;

                this.isMobile = window.innerWidth <= 700;

                this.contentPC = res.filter(v => v.pathKind === "ALL" || v.pathKind === "PC");
                this.contentMobile = res.filter(v => v.pathKind === "ALL" || v.pathKind === "MOBILE");

                setTimeout(() => {
                    this._swiperService.createSwiper(".mainVisual .swiper-container", this.swiperConfig);
                }, 1000);
            }
        });
    }
}
